export enum TransactionType {
    Location = 'Location',
    Vente = 'Vente'
}
